<div class="image-container">
  <ng-container *ngIf="tenant.current.id !== 'feelen'">
    <h2>{{ "INFO_POPUP.HOW_TO_USE" | translate }}</h2>
    <img src="./assets/how-to-use/mind.jpeg" alt="mind">
    <p class="left">{{ "INFO_POPUP.LEFT" | translate }}</p>
    <p class="center">{{ "INFO_POPUP.CENTER" | translate }}</p>
    <p class="right">{{ "INFO_POPUP.RIGHT" | translate }}</p>
  </ng-container>
  <ng-container *ngIf="tenant.current.id === 'feelen' && getCurrentLanguage() === 'de'">
    <svg class="svg-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 500" width="960" height="500" role="img" aria-labelledby="titel beschreibung">
      <title id="titel">Elektrodenpositionen</title>
      <desc id="beschreibung">Zwei Ansichten des Kopfes. Die schwarze Elektrode sitzt oben auf dem Scheitel, auf halber Strecke zwischen Nasenwurzel und Hinterhauptshoecker und auf halber Strecke zwischen beiden Ohren. Die weisse Elektrode gehoert an das linke Ohr, die gelbe an das rechte.</desc>

      <style>
        .haut  { fill: #EAF7F2; stroke: #14312E; stroke-width: 2.4; stroke-linejoin: round; }
        .ohr   { fill: #DAEDE7; stroke: #14312E; stroke-width: 2.2; }
        .helix { fill: none; stroke: #14312E; stroke-width: 2.2; stroke-linecap: round; }
        .band  { stroke: #00A183; stroke-width: 2.6; stroke-dasharray: 8 7; fill: none; stroke-linecap: round; }
        .tick  { stroke: #00A183; stroke-width: 2.6; stroke-linecap: round; }
        .punkt { stroke: #14312E; stroke-width: 2.4; }
        .fuehr { stroke: #9BB5B0; stroke-width: 1.4; fill: none; }
        .kopf  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 600; fill: #14312E; }
        .lab   { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 17px; fill: #14312E; }
        .sub   { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 14px; fill: #5B7370; }
        .mass  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 13px; font-weight: 600; fill: #00806B; }
        .fuss  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 15px; fill: #14312E; }
      </style>

      <!-- ============================ Seitenansicht ============================ -->
      <text class="kopf" x="40" y="42">Von der Seite</text>

      <path class="haut" d="M 122.9 246.4 L 103.0 262.0 L 129.8 274.3 Z"/>
      <circle class="haut" cx="240.0" cy="232.0" r="118.0"/>

      <!-- Ohr im Profil, Laeppchen unten, mit dem weissen Clip daran -->
      <g transform="translate(270.0, 230.0)">
        <path class="ohr" d="M 0 0 c -13 -1 -20 9 -20 22 c 0 15 7 31 18 36 c 9 4 14 -2 14 -11
                         c 0 -9 -5 -13 -7 -18 c 4 -4 7 -12 5 -19 c -2 -7 -5 -10 -10 -10 Z"/>
        <path class="helix" d="M -3 9 c -8 1 -11 8 -10 16 c 1 7 4 12 8 15"/>
      </g>
      <circle class="punkt" cx="281.0" cy="282.0" r="13" fill="#FFFFFF"/>

      <path class="band" d="M 135.3 209.8 A 107.0 107.0 0 0 1 346.0 217.1"/>
      <line class="tick" x1="110.6" y1="200.5" x2="138.3" y2="210.8"/>
      <line class="tick" x1="370.9" y1="208.6" x2="343.0" y2="218.1"/>

      <text class="mass" x="146.4" y="112.2" text-anchor="middle">gleich lang</text>
      <text class="mass" x="341.7" y="119.0" text-anchor="middle">gleich lang</text>

      <circle class="punkt" cx="244.1" cy="114.1" r="15" fill="#111111"/>

      <path class="fuehr" d="M 244.1 99.1 L 244.1 94"/>
      <text class="lab" x="244.1" y="64" text-anchor="middle">schwarze Elektrode</text>
      <text class="sub" x="244.1" y="84" text-anchor="middle">oben auf dem Scheitel</text>

      <path class="fuehr" d="M 124.6 207.5 L 108 366.0"/>
      <text class="lab" x="126" y="400.0" text-anchor="middle">Nasenwurzel</text>
      <text class="sub" x="126" y="421.0" text-anchor="middle">zwischen den Augenbrauen</text>

      <path class="fuehr" d="M 356.9 215.6 L 356 366.0"/>
      <text class="lab" x="340" y="400.0" text-anchor="middle">Hinterkopf</text>
      <text class="sub" x="340" y="421.0" text-anchor="middle">tastbarer Knochenhöcker</text>

      <!-- ============================ Rueckansicht ============================= -->
      <text class="kopf" x="612" y="42">Von hinten</text>

      <ellipse class="ohr" cx="612.0" cy="238.0" rx="19" ry="31"/>
      <ellipse class="ohr" cx="812.0" cy="238.0" rx="19" ry="31"/>
      <ellipse class="haut" cx="712.0" cy="232.0" rx="100.0" ry="126.0"/>

      <path class="band" d="M 617.5 238.0 A 94.5 120.5 0 0 1 806.5 238.0"/>
      <line class="tick" x1="600.0" y1="229.0" x2="620.5" y2="235.0"/>
      <line class="tick" x1="824.0" y1="229.0" x2="803.5" y2="235.0"/>

      <text class="mass" x="608.0" y="130.0" text-anchor="middle">gleich lang</text>
      <text class="mass" x="816.0" y="130.0" text-anchor="middle">gleich lang</text>

      <circle class="punkt" cx="712.0" cy="106.0" r="15" fill="#111111"/>
      <circle class="punkt" cx="610.0" cy="258.0" r="14" fill="#FFFFFF"/>
      <circle class="punkt" cx="814.0" cy="258.0" r="14" fill="#FFC800"/>

      <path class="fuehr" d="M 596.0 258.0 L 590 366.0"/>
      <text class="lab" x="600" y="400.0" text-anchor="middle">linkes Ohr</text>
      <text class="sub" x="600" y="421.0" text-anchor="middle">weiße Elektrode</text>

      <path class="fuehr" d="M 828.0 258.0 L 834 366.0"/>
      <text class="lab" x="824" y="400.0" text-anchor="middle">rechtes Ohr</text>
      <text class="sub" x="824" y="421.0" text-anchor="middle">gelbe Elektrode</text>

      <text class="fuss" x="480" y="478" text-anchor="middle">Die schwarze Elektrode sitzt dort, wo sich beide Strecken treffen. Die beiden Ohrclips kommen an die Ohrläppchen.</text>
    </svg>
  </ng-container>
  <ng-container *ngIf="tenant.current.id === 'feelen' && getCurrentLanguage() === 'en'">
    <svg class="svg-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 500" width="960" height="500" role="img" aria-labelledby="titel beschreibung">
      <title id="titel">Electrode positions</title>
      <desc id="beschreibung">Two views of the head. The black electrode sits on top of the head, halfway between the bridge of the nose and the bony bump at the back of the skull, and halfway between the two ears. The white electrode belongs on the left ear, the yellow one on the right.</desc>

      <style>
        .haut  { fill: #EAF7F2; stroke: #14312E; stroke-width: 2.4; stroke-linejoin: round; }
        .ohr   { fill: #DAEDE7; stroke: #14312E; stroke-width: 2.2; }
        .helix { fill: none; stroke: #14312E; stroke-width: 2.2; stroke-linecap: round; }
        .band  { stroke: #00A183; stroke-width: 2.6; stroke-dasharray: 8 7; fill: none; stroke-linecap: round; }
        .tick  { stroke: #00A183; stroke-width: 2.6; stroke-linecap: round; }
        .punkt { stroke: #14312E; stroke-width: 2.4; }
        .fuehr { stroke: #9BB5B0; stroke-width: 1.4; fill: none; }
        .kopf  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 600; fill: #14312E; }
        .lab   { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 17px; fill: #14312E; }
        .sub   { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 14px; fill: #5B7370; }
        .mass  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 13px; font-weight: 600; fill: #00806B; }
        .fuss  { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 15px; fill: #14312E; }
      </style>

      <!-- ============================ side view ============================ -->
      <text class="kopf" x="40" y="42">From the side</text>

      <path class="haut" d="M 122.9 246.4 L 103.0 262.0 L 129.8 274.3 Z"/>
      <circle class="haut" cx="240.0" cy="232.0" r="118.0"/>

      <!-- ear in profile, lobe at the bottom, with the white clip attached -->
      <g transform="translate(270.0, 230.0)">
        <path class="ohr" d="M 0 0 c -13 -1 -20 9 -20 22 c 0 15 7 31 18 36 c 9 4 14 -2 14 -11
                         c 0 -9 -5 -13 -7 -18 c 4 -4 7 -12 5 -19 c -2 -7 -5 -10 -10 -10 Z"/>
        <path class="helix" d="M -3 9 c -8 1 -11 8 -10 16 c 1 7 4 12 8 15"/>
      </g>
      <circle class="punkt" cx="281.0" cy="282.0" r="13" fill="#FFFFFF"/>

      <path class="band" d="M 135.3 209.8 A 107.0 107.0 0 0 1 346.0 217.1"/>
      <line class="tick" x1="110.6" y1="200.5" x2="138.3" y2="210.8"/>
      <line class="tick" x1="370.9" y1="208.6" x2="343.0" y2="218.1"/>

      <text class="mass" x="146.4" y="112.2" text-anchor="middle">same distance</text>
      <text class="mass" x="341.7" y="119.0" text-anchor="middle">same distance</text>

      <circle class="punkt" cx="244.1" cy="114.1" r="15" fill="#111111"/>

      <path class="fuehr" d="M 244.1 99.1 L 244.1 94"/>
      <text class="lab" x="244.1" y="64" text-anchor="middle">black electrode</text>
      <text class="sub" x="244.1" y="84" text-anchor="middle">on top of the head</text>

      <path class="fuehr" d="M 124.6 207.5 L 108 366.0"/>
      <text class="lab" x="126" y="400.0" text-anchor="middle">bridge of the nose</text>
      <text class="sub" x="126" y="421.0" text-anchor="middle">between the eyebrows</text>

      <path class="fuehr" d="M 356.9 215.6 L 356 366.0"/>
      <text class="lab" x="340" y="400.0" text-anchor="middle">back of the head</text>
      <text class="sub" x="340" y="421.0" text-anchor="middle">the bony bump you can feel</text>

      <!-- ============================ rear view ============================= -->
      <text class="kopf" x="612" y="42">From behind</text>

      <ellipse class="ohr" cx="612.0" cy="238.0" rx="19" ry="31"/>
      <ellipse class="ohr" cx="812.0" cy="238.0" rx="19" ry="31"/>
      <ellipse class="haut" cx="712.0" cy="232.0" rx="100.0" ry="126.0"/>

      <path class="band" d="M 617.5 238.0 A 94.5 120.5 0 0 1 806.5 238.0"/>
      <line class="tick" x1="600.0" y1="229.0" x2="620.5" y2="235.0"/>
      <line class="tick" x1="824.0" y1="229.0" x2="803.5" y2="235.0"/>

      <text class="mass" x="608.0" y="130.0" text-anchor="middle">same distance</text>
      <text class="mass" x="816.0" y="130.0" text-anchor="middle">same distance</text>

      <circle class="punkt" cx="712.0" cy="106.0" r="15" fill="#111111"/>
      <circle class="punkt" cx="610.0" cy="258.0" r="14" fill="#FFFFFF"/>
      <circle class="punkt" cx="814.0" cy="258.0" r="14" fill="#FFC800"/>

      <path class="fuehr" d="M 596.0 258.0 L 590 366.0"/>
      <text class="lab" x="600" y="400.0" text-anchor="middle">left ear</text>
      <text class="sub" x="600" y="421.0" text-anchor="middle">white electrode</text>

      <path class="fuehr" d="M 828.0 258.0 L 834 366.0"/>
      <text class="lab" x="824" y="400.0" text-anchor="middle">right ear</text>
      <text class="sub" x="824" y="421.0" text-anchor="middle">yellow electrode</text>

      <text class="fuss" x="480" y="478" text-anchor="middle">The black electrode goes where the two lines meet. The two clips go on the earlobes.</text>
    </svg>
  </ng-container>
</div>
